import { FC } from "react";
import { ShuttleModal } from "../shuttle-modal";
import { TableShuttles } from "./table-shuttles";
import { ShuttleDetailPanel } from "./shuttle-detail-drawer";

type Props = {};

export const ListShuttles: FC<Props> = () => {
  return (
    <div className="space-y-4">
      <ShuttleModal />
      <TableShuttles />
      <ShuttleDetailPanel />
    </div>
  );
};
